(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["tea-film"] && !Shopify.designMode) return;
  try {
    const teaFilmMobile = window.matchMedia('(max-width: 749px)');
  const prepareTeaFilm = (details) => {
    const mobileTemplate = details.querySelector('template[data-tea-film-mobile]');
    const variant = teaFilmMobile.matches && mobileTemplate ? 'mobile' : 'desktop';
    const template = details.querySelector(`template[data-tea-film-${variant}]`);
    const slot = details.querySelector('[data-tea-film-slot]');
    if (!template || !slot) return;
    const film = details.closest('.tea-discovery__film');
    if (film) film.dataset.teaFilmActiveVariant = variant;
    if (details.dataset.teaFilmVariant === variant) return slot.querySelector('video');
    details.querySelectorAll('video').forEach((video) => video.pause());
    slot.replaceChildren(template.content.cloneNode(true));
    details.dataset.teaFilmVariant = variant;
    return slot.querySelector('video');
  };
  document.addEventListener('click', (event) => {
    const summary = event.target.closest('details[data-tea-film] > summary');
    if (!summary || summary.parentElement.open) return;
    const video = prepareTeaFilm(summary.parentElement);
    if (video) video.play().catch(() => {});
  });
  document.addEventListener('toggle', (event) => {
    const details = event.target;
    if (!(details instanceof HTMLDetailsElement) || !details.matches('details[data-tea-film]')) return;
    if (details.open) prepareTeaFilm(details);
    else {
      details.querySelectorAll('video').forEach((video) => video.pause());
      const film = details.closest('.tea-discovery__film');
      if (film) delete film.dataset.teaFilmActiveVariant;
    }
  }, true);
  document.addEventListener('play', (event) => {
    const activeVideo = event.target;
    if (!(activeVideo instanceof HTMLVideoElement) || !activeVideo.closest('details[data-tea-film]')) return;
    document.querySelectorAll('details[data-tea-film] video').forEach((video) => {
      if (video !== activeVideo) video.pause();
    });
  }, true);
  document.querySelectorAll('details[data-tea-film][open]').forEach(prepareTeaFilm);
  } catch(e) { console.error(e); }
})();

})();
